export enum LAYER_SETTINGS_TYPES {
    CUSTOM,
    STRING, 
    INT, 
    FLOAT, 
    COLOR, 
    BOOLEAN, 
    SELECT, 
    GROUP_SIMPLE, 
    GROUP_CHECKED,
    GROUP_CHECKED_01,
    DATE,
    TITLE,
}